// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"StaticHeader__materialize-textarea___3P2pA","modal-2463794813":"StaticHeader__modal-2463794813___15IkH","container":"StaticHeader__container___2a3nk","aboutUsHeader":"StaticHeader__aboutUsHeader___2YU44","sportsHeader":"StaticHeader__sportsHeader___1Pke-","bottomText":"StaticHeader__bottomText___3yQn_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticPageHeader/StaticHeader.scss
// module id = 1539
// module chunks = 0